import { cn } from "@/lib/utils";

/** Floating list panel — pairs with `.glass-overlay.glass-menu` in glass.css. */
export const glassMenuPanelClassName =
  "glass-overlay glass-menu overflow-y-auto p-1 shadow-lg";

export function glassMenuItemClassName(
  active?: boolean,
  size: "sm" | "default" = "default",
) {
  return cn(
    "flex w-full rounded-md text-left outline-none transition-colors",
    size === "sm" ? "px-2 py-1.5 text-xs" : "px-2 py-1.5 text-sm",
    active
      ? "bg-primary/12 text-foreground"
      : "hover:bg-accent/50 focus-visible:bg-accent/50",
  );
}
